import React, { useState, useEffect } from 'react';
import { Box, Button, CircularProgress, FormControl, FormHelperText, MenuItem, Modal, Select, TextField } from '@mui/material';
import { createErrorMessage } from '../../../../../utils/index';
import { createBonusTransactionValidation } from '../../../../../validations/PaymentTool/createBonusTransactionValidation';
import { useCreateTransactionAdjustmentMutation, useEditTransactionAdjustmentMutation, useGetTransactionsQuery } from '../../../../../services/PaymentToolApi';
import { useNotification } from '../../../../../context/NotificationContext';

const ModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 350,
  padding: '1em',
  bgcolor: 'background.paper',
  borderRadius: '1em',
  boxShadow: 24,
}

export default function EditBonusTransactionModal({isOpen, setIsOpen, selectedTransaction}) {

  const { showNotification } = useNotification();

  const [formValues, setFormValues] = useState({ amount: '', notesForBee: '', notesForAdmin: ''});
  const [formErrors, setFormErrors] = useState({});

  const [updateTransaction, { data: updatedTransaction, isLoading: updateTransactionIsLoading, isError: updateTransactionIsError, error: updateTransactionError }] = useEditTransactionAdjustmentMutation();
  function handleBonusSave(formValues) {
    let newBonus={
      "id": selectedTransaction.id,
      //info entered by admin
      "amount": formValues.amount,
      "notesForBee": formValues.notesForBee,
      "notesForAdmin": formValues.notesForAdmin
    }
    updateTransaction(newBonus).unwrap()
      .then((res) => {
        console.log(res);
        setIsOpen(false);
        showNotification('Bonus edited successfully', 'success');
      })
      .catch((err) => {
        console.log(err);
        setIsOpen(false);
        showNotification(createErrorMessage(err), 'error');
      });
  }

  const handleCloseBonus = () => {
    setFormValues({ amount: '', comments: '' });
    setFormErrors({ amount: '', comments: '' });
    setIsOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormErrors({ amount: '', comments: '', notesForBee: '', notesForAdmin: '' });
    
    createBonusTransactionValidation.validate(formValues, { abortEarly: false })
      .then(() => {
        handleBonusSave(formValues);
      })
      .catch((err) => {
        const errors = {};
        err.inner.forEach((error) => {
          errors[error.path] = error.message;
        });
        setFormErrors(errors);
      });
  };

  useEffect(() => {
    if (selectedTransaction) {
      setFormValues(prevState => ({
        ...prevState,
        ...selectedTransaction
      }));
    }
  }, [selectedTransaction, isOpen]);

  const handleDeleteTransaction = () => {
    console.log("deleting: ", selectedTransaction)
    let editedBonus = {
      "id": selectedTransaction.transactionID || selectedTransaction.id,
      "isDeleted": true
    }
    console.log("editedBonus: ", editedBonus)
    updateTransaction(editedBonus).unwrap()
      .then((res) => {
        console.log(res);
        setFormValues({ amount: '', notesForBee: '', notesForAdmin: '' });
        setIsOpen(false);
        showNotification('Bonus Deleted successfully', 'success');
      })
      .catch((err) => {
        console.log(err);
        setIsOpen(false);
        showNotification(createErrorMessage(err), 'error');
      });
  }

  return (
    <>

      <Modal
        open={isOpen}
        onClose={handleCloseBonus}
      >
        <Box sx={ModalStyle}>
          <form noValidate onSubmit={handleSubmit}>
            <p style={{ color: 'var(--orange)', margin: '0 0 0.5em 0' }}>Edit Bonus</p>

            <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Amount</p>
            <TextField 
              name="amount"
              required
              value={formValues.amount}
              onChange={handleChange}
              error={!!formErrors.amount}
              helperText={formErrors.amount}
              sx={{ width: '100%', margin: '0 0 1em 0' }}
            />

            {/* WRITE BEE COMMENTS */}
            <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Reason Details (Visible for Bee)</p>
            <TextField
              multiline
              rows={4}
              name="notesForBee"
              value={formValues.notesForBee}
              onChange={handleChange}
              sx={{ width: '100%', margin: '0 0 1em 0' }}
              error={!!formErrors.notesForBee}
              helperText={formErrors.notesForBee}
            />

            {/* WRITE ADMIN COMMENTS */}
            <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Internal Notes (Visible only for Admins)</p>
            <TextField
              multiline
              rows={4}
              name="notesForAdmin"
              value={formValues.notesForAdmin}
              onChange={handleChange}
              sx={{ width: '100%', margin: '0 0 1em 0' }}
              error={!!formErrors.notesForAdmin}
              helperText={formErrors.notesForAdmin}
            />

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button variant='outlined' color='error' sx={{ minWidth: '100px' }} name="deleteButton" onClick={handleDeleteTransaction} disabled={updateTransactionIsLoading} >
                Delete
              </Button>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button variant='contained' color='secondary' sx={{ minWidth: '100px', margin:'0 1em 0 0' }} name="cancelButton" onClick={handleCloseBonus}>Cancel</Button>
                <Button variant='contained' type="submit" name="acceptButton" color='primary' sx={{ minWidth: '100px' }} disabled={updateTransactionIsLoading} >{ updateTransactionIsLoading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Ok" }</Button>
              </div>

            </div>

          </form>
        </Box>
      </Modal>
    </>
  );
}
